import { request } from "./request";

// 频道
export const getChannel = () => {
  return request({
    url: "/api/getNewsChannels",
    method: "get",
  });
};

export const getList = (params) => {
  return request({
    url: "/api/getNewsList/",
    method: "get",
    data: params,
  });
};

export const getView = (params) => {
  return request({
    url: "/api/getNews/",
    method: "get",
    data: params,
  });
};

export const getRank = () => {
  return request({
    url: "/api/getDailyNews/",
    method: "get",
  });
};

export const getRelatedNews = (params) => {
  return request({
    url: "/api/getRelatedNews/",
    method: "get",
    data: params,
  });
};

export const getTonglan = (params) => {
  return request({
    url: "/api/getHeadline/",
    method: "get",
    data: params,
  });
};

export const getWechatConfig = (params) => {
  return request({
    url: "/api/getWechatConfig/",
    method: "get",
    data: params,
  });
};
